import moment from "jalali-moment";

export function convertUniversalDateToPersianDate(date) {
    if (date && date.length > 0) {
        return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
    }
}

export function convertUniversalDateTimeToPersianDateTime(date) {
    if (typeof date !== 'undefined' && date && date.length > 0) {
        const utcDateTime = date.toString().split("T")

        if (typeof utcDateTime !== 'undefined' && typeof utcDateTime[1] !== 'undefined') {

            const utcTime = utcDateTime[1].toString().split(":")

            const newDate = new Date();
            newDate.setUTCHours(utcTime[0], utcTime[1], utcTime[2])

            return `${newDate.toLocaleTimeString('fa-IR')} - ${moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}`
        } else
            return moment(date, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
    } else
        return "-"
}

export function convertUniversalDateToPersianDateFullInfo(date) {
    if (date && date.length > 0) {
        return moment(date, 'YYYY-MM-DD').locale('fa').format('dddd . DD MMMM YYYY')
    }
}

export function convertPersianDateToUniversalDate(date) {
    if (date && date.length > 0) {
        return moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    } else
        return ""
}


export function convertUniversalTimeToPersianTime(time) {
    try {
        return moment(time, 'YYYY-MM-DD').locale('fa').format('HH:mm')
    } catch (e) {
        return "00:00:00"
    }
}


/**
 * محاسبه مدت زمان عضویت کاربر از تاریخ signupAt تا الان
 * @param {string} signupAt - تاریخ عضویت به فرمت ISO (مثلا "2022-12-31T07:59:44.260327")
 * @returns {object} - شامل years, months, days, hours, minutes و یک متن خوانا
 */
export function calculateMembershipDuration(signupAt) {
    const signupDate = new Date(signupAt);
    const now = new Date();

    if (isNaN(signupDate.getTime())) {
        throw new Error("تاریخ signupAt معتبر نیست");
    }

    // اختلاف کل بر حسب میلی‌ثانیه
    let diffMs = now - signupDate;

    if (diffMs < 0) {
        return {years: 0, months: 0, days: 0, hours: 0, minutes: 0, text: "تاریخ در آینده است"};
    }

    // محاسبه سال و ماه با دقت تقویمی (نه فقط تقسیم عددی)
    let years = now.getFullYear() - signupDate.getFullYear();
    let months = now.getMonth() - signupDate.getMonth();
    let days = now.getDate() - signupDate.getDate();
    let hours = now.getHours() - signupDate.getHours();
    let minutes = now.getMinutes() - signupDate.getMinutes();

    if (minutes < 0) {
        minutes += 60;
        hours -= 1;
    }
    if (hours < 0) {
        hours += 24;
        days -= 1;
    }
    if (days < 0) {
        // تعداد روزهای ماه قبل رو اضافه می‌کنیم
        const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
        days += prevMonth.getDate();
        months -= 1;
    }
    if (months < 0) {
        months += 12;
        years -= 1;
    }

    let text = ``;

    if (years > 0)
        text = `${text} ${years}  سال`;

    if (months > 0)
        text = `${text} ${months}  ماه`;

    if (days > 0)
        text = `${text} ${days}  روز`;

    if (hours > 0)
        text = `${text} ${hours}  ساعت`;

    return {years, months, days, hours, minutes, text};
}

// مثال استفاده
const result = calculateMembershipDuration("2022-12-31T07:59:44.260327");
console.log(result);
// { years: 3, months: 6, days: 5, hours: 14, minutes: 22, text: "3 سال، 6 ماه، 5 روز و 14 ساعت" }